// @flow
import { createAction } from 'redux-act';

import type { FetchResponse } from '@gandi/resource/redux';

import { GET } from 'gandi.redux-fetcher';
import { logging } from 'gandi.redux-logger';

import type { GetState, Dispatch } from '../../../types';
import { selectAllTLDs } from '../selectors/tlds';

const loggerNamespace = 'DomainCreate/modules/actions/tlds';

export const set: any = createAction('[tlds] Set');

export const fetchAllTLDs =
  (): ((dispatch: Dispatch, getState: GetState) => Promise<void>) =>
  (dispatch: Dispatch, getState: GetState) => {
    const logger = logging(dispatch, loggerNamespace);

    if (selectAllTLDs(getState()).length > 0) return Promise.resolve();

    return dispatch(
      // This fetch is intercepted by the TLDsMiddleware
      GET('/tlds', {
        // $FlowFixMe[incompatible-call]
        on200: (response: FetchResponse<>) => {
          const tlds = response.data;

          if (Array.isArray(tlds) && tlds.length > 0) {
            dispatch(set(tlds));
          }

          return response;
        },
        not200: () => {
          logger.error('Unable to fetch TLDs');
        },
      }),
    );
  };
